import merge from 'webpack-merge'
import axios from 'axios'

axios.defaults.timeout = 10000;
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.baseURL=''; //     /api       http://192.168.25.20:11443             https://www.airgo.link:21443           http://cast.hellogo.tech

let Ajax = {}
/**
 *
 * @param prop
 * {
 *   post:{
 *    url:string,
 *    data: {}
 *    },
 *   then:(function res)
 *   catch: (function err)
 *   }
 * }
 */
Ajax.post = function (prop) {
  const DEFAULTPROPS = {
    method: 'post',
    transformRequest: [function (data) {
      // let arr = []
      // for (let it in data) {
      //   if (data.hasOwnProperty(it)) {
      //     arr.push(encodeURIComponent(it) + '=' + encodeURIComponent(data[it]))
      //   }
      // }
      // return arr.join('&')
      return JSON.stringify(data);
    }],
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }

  let props = merge(DEFAULTPROPS, prop.post);
  axios(props).then(response => {
    var res = response.data
    if (prop.then && (typeof (prop.then)).toLowerCase() === 'function') {
      prop.then(res)
    }
  }).catch(err => {
    //console.log(err)
    if (prop.catch && (typeof (prop.catch)).toLowerCase() === 'function') {
      prop.catch(err)
    }
  })
}

Ajax.get = function (prop) {
  console.log("get => ", prop);
  
  const DEFAULTPROPS = {
    method: 'get',
    transformRequest: [function (data) {
      return data;
    }],
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }
  console.log("get => ", DEFAULTPROPS);

  let props = merge(DEFAULTPROPS, prop.get);
  axios(props).then(response => {
    var res = response.data
    if (prop.then && (typeof (prop.then)).toLowerCase() === 'function') {
      prop.then(res)
    }
  }).catch(err => {
    //console.log(err)
    if (prop.catch && (typeof (prop.catch)).toLowerCase() === 'function') {
      prop.catch(err)
    }
  })
}

export default Ajax